import { createContext } from 'react';
import { type Language } from '../types/language';

const AdminContext = createContext({});

export const AdminProvider = AdminContext.Provider;

export default AdminContext;

export interface AdminContextType {
  language?: Language;
  languageCode?: string;
  drawerState?: 'collapsed' | 'expanded';
  user?: { id?: string; enovaPersonalGuid?: string; [key: string]: unknown };
}
